import { useEffect } from "react";

const SITE_URL = "https://indianecofuel.com";
const DEFAULT_TITLE = "Indian Eco Fuels | Biofuels, Bio-CNG & Clean Energy Solutions";
const DEFAULT_DESCRIPTION =
  "Indian Eco Fuels develops biofuel, Bio-CNG, EV charging and sustainable energy solutions for a cleaner India.";

const PAGE_METADATA = {
  "/": {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  "/enquiry": {
    title: "Partner Enquiry | Indian Eco Fuels",
    description:
      "Explore clean-energy franchise, investment and infrastructure opportunities with Indian Eco Fuels.",
  },
  "/careers": {
    title: "Careers | Indian Eco Fuels",
    description:
      "Build India's sustainable energy future with Indian Eco Fuels. Discover career opportunities in clean energy.",
  },
  "/terms": {
    title: "Terms & Trade Notice | Indian Eco Fuels",
    description:
      "Read the Indian Eco Fuels terms and trade notice for our biofuel partnership and supply operations.",
  },
};

function setMeta(selector, attribute, value) {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute(attribute, value);
}

export default function PageSeo({ pathname }) {
  useEffect(() => {
    const page = PAGE_METADATA[pathname] || PAGE_METADATA["/"];
    const canonicalUrl = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;

    document.title = page.title;
    setMeta('meta[name="description"]', "content", page.description);
    setMeta('meta[property="og:title"]', "content", page.title);
    setMeta('meta[property="og:description"]', "content", page.description);
    setMeta('meta[property="og:url"]', "content", canonicalUrl);
    setMeta('meta[name="twitter:title"]', "content", page.title);
    setMeta('meta[name="twitter:description"]', "content", page.description);
    setMeta('link[rel="canonical"]', "href", canonicalUrl);

  }, [pathname]);

  return null;
}
